import { useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import { Spinner } from "../../../components";
import { ClientProps } from "../../../interfaces/interfaces";
import { PumpTrackerAdmin } from "./PumpTrackerAdmin";

export const PumpTrackerClient = () => {
  const [clients, setClients] = useState<ClientProps[]>([]);
  const [selectedClientId, setSelectedClientId] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const controller = new AbortController();
    fetch(
      String(process.env.REACT_APP_DEV_API) + "/user-client-assignments",
      {
        signal: controller.signal,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("info"),
        },
      },
    )
      .then(async (response) => {
        const result = await response.json();
        if (!response.ok || !result.success) {
          throw new Error(result.error || "Assigned clients could not be loaded");
        }
        const assignedClients = result.data as ClientProps[];
        setClients(assignedClients);
        setSelectedClientId(assignedClients[0]?.id ?? null);
      })
      .catch((requestError) => {
        if (
          requestError instanceof DOMException &&
          requestError.name === "AbortError"
        ) return;
        setError(
          requestError instanceof Error
            ? requestError.message
            : "Assigned clients could not be loaded",
        );
      })
      .finally(() => {
        if (!controller.signal.aborted) setLoading(false);
      });
    return () => controller.abort();
  }, []);

  if (loading) return <Spinner message="Loading assigned clients..." />;
  if (error || !clients.length) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity={error ? "error" : "info"}>
          {error || "No active clients are assigned to this user."}
        </Alert>
      </Box>
    );
  }
  return (
    <PumpTrackerAdmin
      clientMode
      assignedClientOptions={clients}
      assignedClientId={selectedClientId}
      onAssignedClientChange={setSelectedClientId}
    />
  );
};
